import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function mentorDataReducer(
  state = initialState.mentorsData,
  action
) {
  if (action.type === types.LOAD_MENTORS_DATA_SUCCESS) {
      return action.mentorsData;
    }
    return state;
}
